import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@ng-idle/core';
import { DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';

class IdleService {
    constructor(idle) {
        this.idle = idle;
        this.state = 0 /* ACTIVE */;
        this.timedOut = false;
        this.noTimeOut = new Set(['/error/time-out', '/login']);
    }
    set(idleTime, timeoutTime) {
        this.idle.setIdle(idleTime);
        // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
        this.idle.setTimeout(timeoutTime);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    }
    get() {
        return this.idle;
    }
    getState() {
        return this.state;
    }
    reset() {
        this.idle.watch();
        this.state = 0 /* ACTIVE */;
        this.timedOut = false;
    }
}
IdleService.ɵfac = function IdleService_Factory(t) { return new (t || IdleService)(i0.ɵɵinject(i1.Idle)); };
IdleService.ɵprov = i0.ɵɵdefineInjectable({ token: IdleService, factory: IdleService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IdleService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.Idle }]; }, null); })();

/*
 * Public API Surface of idle
 */
// export * from './lib/idle.module';

/**
 * Generated bundle index. Do not edit.
 */

export { IdleService };
//# sourceMappingURL=idle.js.map
